<template>
  <div :class="type">
    <!-- @todo Enable card but then create layout for Header, Body and Footer-->
    <!--
    <v-card class="sblock" elevation="0" tile>
      <v-card-text>
        -->
        <slot/>
    <!--
      </v-card-text>
    </v-card>
    -->
  </div>
</template>
<script>
  export default {
    name: 'SectionLayout',
    data() {
      return {
        type: 'root',
        loaded: false
      }
    },
    mounted() {
      this.loaded = true;
      this.type = this.blockType === 'Videos' ? 'root_video': 'root';
    },
    props: {
      cols: Number,
      blockType: {
        type: String,
        default: 1
      }
    },
    computed: {
      isDesktop() {
        const lgUp = ['lgDown', 'xl']
        return lgUp.indexOf(this.$mq) > -1
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/styles';
  .root_video {
    position: relative;
    /*z-index: 55;*/
    .container {
      position: relative
    }
  }

  .root {
    display: block;
    text-align: center;
    margin-bottom: $spacing5;
     & .container {
      max-width: 1100px
    }
    @include breakpoints-down(xs) {
      margin-bottom: $spacing10
    }
  }

  .subtitle {
    margin-bottom: $spacing5
  }

  .decoration {
    position: absolute;
    width: 1280px;
    height: 960px;
    svg {
      width: 1280px;
      height: 100%;
      @include use-theme(fill, $palette-secondary-light, $palette-secondary-dark);
      opacity: 0.2;
      @include breakpoints-up(lg) {
        transform: scale(1.7, 1)
      }
      @include breakpoints-up(xl) {
        display: none
      }
      @include breakpoints-down(xs) {
        transform: scale(0.5);
        transform-origin: center left
      }
    }
  }

  .item {
    &:hover {
      /*z-index: 56 !important*/
    }
  }

  .pricing-wrap > section {
    align-items: center;
    margin-top: $spacing3;
    display: flex;
    @include breakpoints-down(sm) {
      flex-wrap: wrap;
      justify-content: space-around
    }
    @include breakpoints-up(lg) {
      padding: spacing(0, 5)
    }
    > * {
      margin: 0 -8px
    }
    > *:first-child, & > *:last-child {
      z-index: 1
    }
  }
</style>